<template>
  <div>
    <h1>Gestion des tickets</h1>
    <div class="trello-container">
      <ul class="boards-summarize">
        <li v-for="board of Object.values(boardsOverview)" :key="board.name" class="board-box">
          <h3>
            <label class="d-flex justify-content-between">
              {{board.name}}
              <input type="checkbox" v-model="selectedBoards" :value="board.id" />
              <div class="mark"></div>
            </label>
          </h3>
          <div class="counts">
            {{board.total}} affectés<br />
            {{board.done}} terminés / {{board.test}} à tester / {{board.doing}} en cours / {{board.todo}} à traiter
          </div>
          <ProgressBar class="progress-bar"
                       borderColor="#A7C13C"
                       :percentList="[
                        {percent: board.percentDone, color: '#A7C13C'},
                        {percent: board.percentTest, color: 'rgb(242, 214, 0)'},
                        {percent: board.percentDoing, color: 'rgb(242, 162, 64)'},
                        {percent: board.percentTodo, color: 'white'},
                       ]" />
          <ul class="badges">
            <li class="priority-badge">Mineur: {{board.minor}}</li>
            <li class="priority-badge">Majeur: {{board.major}}</li>
            <li class="priority-badge">Bloquant: {{board.blocking}}</li>
          </ul>
        </li>
      </ul>
      <div class="table-container">
        <div class="heading">
          <h3>Tâches à réaliser</h3>
          <label v-if="isAdmin">
            <input type="checkbox" v-model="userFiltered" />
            Uniquement mes tâches
          </label>
        </div>
        <vue-good-table class="card-table"
                        :columns="columns"
                        :rows="displayCards"
                        :pagination-options="{
                                        enabled: true,
                                        rowsPerPageLabel: 'Lignes par page',
                                        ofLabel: 'sur',
                                        nextLabel: 'Suivant',
                                        prevLabel: 'Précédent',
                                        allLabel: 'Toutes'
                                    }"
                        :sort-options="{
                                        enabled: true,
                                        multipleColumns: true,
                                        initialSortBy: {field: 'priorityLevel', type: 'asc'}
                                      }"
                        compactMode>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'boardName' && props.row.custom">
              {{props.row.initialDesc.projet}}
            </span>
            <span v-else-if="props.column.field == 'listType'">
              {{props.row.listName}}
            </span>
            <span v-else-if="props.column.field == 'priorityLevel'">
              <div class="priorityBadge" :class="'priority-' + props.row[props.column.field]"></div>
            </span>
            <span v-else-if="props.column.field == 'shortUrl'">
              <a :href="props.row[props.column.field]" target="_blank">
                <font-awesome-icon icon="external-link-alt"></font-awesome-icon>
              </a>
            </span>
            <span v-else-if="props.column.field == 'id'">
              <router-link :to="{ path: '/tickets/detail', query: { id: props.row[props.column.field] } }">
                <font-awesome-icon icon="external-link-alt"></font-awesome-icon>
              </router-link>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
      <div>
        <Calendar :cards="displayCards" @filterDue="dueFilter=$event" :dueFilter="dueFilter" />
        <div v-if="isAdmin" class="toBeClassifiedBoard">
          <h2>A classifier - Tableau Interne</h2>
          <ul>
            <li v-for="card of toCategorizeCards" :key="card.id" class="d-flex flex" @click="$router.push({ path: '/tickets/detail', query: { id: card.id } })">
              <div class="initiales">{{card.initialDesc.demandeur.initiales}}</div>
              <div class="content">
                <div class="type">{{card.typeLabel}}</div>
                <div class="desc">{{card.initialDesc.projet}} - {{card.name}}</div>
              </div>
              <small v-if="card.initialDesc.priorite" :class="'badge label-' + card.initialDesc.priorite.color">
                {{card.initialDesc.priorite.label}}
              </small>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { uniq } from "@/utils"
  import { getCards } from "@/utils/trello"
  import Calendar from "@/components/TrelloCalendar"
  import ProgressBar from "@/components/ProgressBar"

  export default {
    name: "Tickets",
    components: { Calendar, ProgressBar },
    data() {
      return {
        allRawCards: [],
        rawCards: [],
        dueFilter: "",
        userFiltered: true,
        selectedBoards: []
      }
    },
    mounted() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        getCards().then(res => {
          this.allRawCards = res.map(card => ({
            ...card,
            descExcerpt: card.desc.slice(0, 100) + (card.desc.length > 100 ? "..." : ""),
            typeLabel: this.getCardType(card),
            due: this.formatDate(card.due),
            start: this.formatDate(card.start),
          }))

          this.rawCards = this.allRawCards.filter(c => c.listType);
          this.selectedBoards = Object.keys(this.$store.state.trelloConfig.boardConfig);
        });
      },
      getCardType(card) {
        let res = [];
        for (const label of card.labels) {
          if (["Mineur", "Majeur", "Bloquant"].indexOf(label.name) === -1) {// Il ne s'agit pas d'un indicateur de priorité
            res.push(label.name);
          }
        }
        return res.sort().join(" / ")
      },
      formatDate(dateString) {
        if (!dateString) return null;
        const dateObj = new Date(dateString);
        return `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1 < 10) ? "0" : ""}${dateObj.getMonth() + 1}-${(dateObj.getDate() < 10) ? "0" : ""}${dateObj.getDate()}`
      }
    },
    computed: {
      isAdmin() {
        return this.$store.state.trelloConfig.userConfig.find(u => u.id == this.$store.state.self.userSdcGuid) ? true : false;
      },
      cards() { // Retourne la liste de cartes filtrées par user
        return this.rawCards
          .filter(c => c.membersSdc && c.membersSdc.length > 0)
          .filter(c => !this.userFiltered || c.membersSdc.indexOf(this.$store.state.self.userSdcGuid) !== -1)
      },
      toCategorizeCards() {
        // Demandes internes non attribuées
        return this.allRawCards.filter(c => c.idBoard == this.$store.state.trelloConfig.internalBoard.idBoard && c.idList == this.$store.state.trelloConfig.internalBoard.idList && c.idMembers.length == 0)
      },
      displayCards() {
        return this.cards
          .filter(c => c.listType != "done")
          .filter(c => this.selectedBoards.indexOf(c.idBoard) != -1)
      },
      boardsOverview() { // Récupération des données récapitulatives d'un tableau
        let res = {};
        for (const idBoard in this.$store.state.trelloConfig.boardConfig) { // Pour chaque tableau configuré
          const cardOnBoard = this.cards.find(c => c.idBoard == idBoard);
          if (!cardOnBoard) continue; // Si on ne trouve aucune carte du tableau, on n'affiche pas ce tableau
          let boardRes = this.cards.reduce((acc, card) => {
            if (card.idBoard == idBoard) {
              // On compte les cartes selon leur liste (todo/doing/done)
              if (card.listType)
                acc = { ...acc, [card.listType]: acc[card.listType] + 1 }

              // On compte les cartes selon leur priorité
              const priorities = {
                4: "undefined",
                3: "minor",
                2: "major",
                1: "blocking"
              }
              if (priorities[card.priorityLevel])
                acc = { ...acc, [priorities[card.priorityLevel]]: acc[priorities[card.priorityLevel]] + 1 }
            }
            return acc
          }, { todo: 0, done: 0, doing: 0, test: 0, minor: 0, major: 0, blocking: 0, undefined: 0 })

          boardRes.total = boardRes.todo + boardRes.done + boardRes.doing + boardRes.test;
          boardRes.percentDone = boardRes.total == 0 ? 0 : boardRes.done / boardRes.total * 100
          boardRes.percentTest = boardRes.total == 0 ? 0 : boardRes.test / boardRes.total * 100
          boardRes.percentDoing = boardRes.total == 0 ? 0 : boardRes.doing / boardRes.total * 100
          boardRes.percentTodo = boardRes.total == 0 ? 0 : boardRes.todo / boardRes.total * 100
          boardRes.name = cardOnBoard.boardName
          boardRes.id = idBoard

          res[idBoard] = boardRes
        }
        return res;
      },
      columns() {
        const uniqBoards = uniq(this.displayCards.map(c => c.boardName));
        const listTypes = [
          { value: "todo", text: "A faire" },
          { value: "doing", text: "En cours"},
          { value: "test", text: "A tester"},
        ]
        const labels = []
        this.displayCards.forEach(c => {
          labels.push(...(c.labels.map(l => l.name).filter(l => (["Mineur", "Majeur", "Bloquant"].indexOf(l) === -1))))
        })
        const uniqLabels = uniq(labels)
        return [
          {
            label: "Projet", field: "boardName", filterOptions: {
              enabled: true,
              placeholder: "Tous",
              filterDropdownItems: uniqBoards
            }
          },
          {
            label: "Statut", field: "listType", filterOptions: {
              enabled: true,
              placeholder: "Tous",
              filterDropdownItems: listTypes,
            }
          },
          { label: "Titre", field: "name", filterOptions: { enabled: true } },
          {
            label: "Type", field: "typeLabel", filterOptions: {
              enabled: true,
              placeholder: "Tous",
              filterDropdownItems: uniqLabels,
              filterFn: (data, filter) => {
                if (data.indexOf(filter) !== -1)
                  return true;
                return false;
              }
            }
          },
          { label: "Description", field: "descExcerpt", filterOptions: { enabled: true } },
          { label: "Echéance", field: "due", type: "date", dateInputFormat: "yyyy-MM-dd", dateOutputFormat: "dd/MM/yyyy", filterOptions: { enabled: true, filterValue: this.dueFilter, styleClass: "hidden" } },
          {
            label: "Priorité", field: "priorityLevel", tdClass: "text-center", filterOptions: {
              enabled: true,
              placeholder: "Tous",
              filterDropdownItems: [
                { value: 4, text: 'Non défini' },
                { value: 3, text: 'Mineur' },
                { value: 2, text: 'Majeur' },
                { value: 1, text: 'Bloquant' }
              ]
            }
          },
          { label: "Détail", field: "id", sortable: false }
        ]
      }
    }
  }
</script>

<style scoped>
  .trello-container {
    display: grid;
    grid-template-columns: 380px 1fr 350px;
    column-gap: 24px;
  }

  .table-container {
    padding: 1rem;
    border-radius: 12px;
    background-color: white;
    box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
    overflow-x: hidden;
  }

    .table-container .heading {
      display: flex;
      justify-content: space-between;
    }

  .priorityBadge {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: black;
    margin: auto;
  }

    .priorityBadge.priority-4 {
      background-color: transparent;
      border: 1px solid #CCC;
    }

    .priorityBadge.priority-3 {
      background-color: rgb(237, 215, 71);
    }

    .priorityBadge.priority-2 {
      background-color: rgb(242, 162, 64);
    }

    .priorityBadge.priority-1 {
      background-color: rgb(218, 100, 79);
    }

  .boards-summarize {
    list-style-type: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }

    .boards-summarize .board-box {
      width: 100%;
      background-color: white;
      box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
      border-radius: 12px;
      padding: 1rem;
    }

      .boards-summarize .board-box h3 {
        font-size: 1.15rem;
        font-weight: bold;
        position: relative;
        padding-bottom: 15px;
        margin-bottom: 15px;
        border-bottom: 2px solid #F3F3F3;
      }

        .boards-summarize .board-box h3 label {
          position: relative;
        }

          .boards-summarize .board-box h3 label:hover {
            cursor: pointer;
          }

        .boards-summarize .board-box h3 input {
          opacity: 0;
        }

          .boards-summarize .board-box h3 input + .mark {
            display: block;
            position: absolute;
            top: calc(50% - 8px);
            right: 16px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #888;
            background-color: white;
            transition: all ease 180ms;
          }

          .boards-summarize .board-box h3 input:checked + .mark {
            border: 1px solid #A7C13C;
            background-color: #A7C13C;
          }

      .boards-summarize .board-box .progress-bar {
        margin-bottom: 15px;
        height: 16px;
      }

      .boards-summarize .board-box .badges {
        list-style-type: none;
        padding: 0;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 8px;
      }

  .badges .priority-badge {
    width: 100%;
    padding: 0.5rem 0.7rem;
    color: white;
    font-size: 0.8rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
  }

    .badges .priority-badge:nth-child(1) {
      background-color: rgb(237, 215, 71);
    }

    .badges .priority-badge:nth-child(2) {
      background-color: rgb(242, 162, 64);
    }

    .badges .priority-badge:nth-child(3) {
      background-color: rgb(218, 100, 79);
    }

  .toBeClassifiedBoard {
    margin-top: 1rem;
    padding: 1rem;
    border-radius: 12px;
    background-color: white;
    box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
    height: min-content;
  }

    .toBeClassifiedBoard h2 {
      font-weight: bold;
      padding-bottom: 0.5rem;
      margin-bottom: 0.3rem;
      border-bottom: 1px solid #EEE;
      font-size: 1rem;
    }

    .toBeClassifiedBoard ul {
      padding: 0;
      margin: 0;
      list-style-type: none;
    }

    .toBeClassifiedBoard li {
      display: flex;
      column-gap: 4px;
      align-items: center;
      padding-bottom: 0.5rem;
      margin-top: 0.5rem;
      border-bottom: 1px solid #EEE;
    }

      .toBeClassifiedBoard li:hover {
        cursor: pointer;
      }

      .toBeClassifiedBoard li .initiales {
        width: 32px;
        height: 32px;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #A7C13C;
        border-radius: 50%;
        font-weight: bold;
        color: white;
      }

      .toBeClassifiedBoard li .content {
        overflow: hidden;
      }

        .toBeClassifiedBoard li .content .desc {
          font-size: 0.8rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

      .toBeClassifiedBoard li .badge {
        font-weight: normal;
      }
</style>

<style>

  .hidden {
    opacity: 0;
    pointer-events: none;
  }


  .card-table {
    max-width: 100%;
    overflow-x: scroll;
  }

    .card-table table,
    .card-table thead,
    .card-table thead th,
    .card-table th,
    .card-table td {
      border: none !important;
    }

    .card-table thead {
      border-top: 1px solid #CCC !important;
      border-bottom: 1px solid #CCC !important;
    }

      .card-table thead th {
        background: white;
        text-align: center;
      }

    .card-table td {
      /*max-width: 200px;*/
    }

      .card-table td a {
        color: black;
        text-decoration: none;
      }
</style>



// WEBPACK FOOTER //
// src/pages/GestionProjet/Tickets.vue